import { render, staticRenderFns } from "./PropertyInvestmentFieldset.vue?vue&type=template&id=fc9a8118&scoped=true"
import script from "./PropertyInvestmentFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyInvestmentFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyInvestmentFieldset.vue?vue&type=style&index=0&id=fc9a8118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9a8118",
  null
  
)

export default component.exports